// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"157":"f901781edabf5c62ab94","171":"2305a4c0964a36d1ea84","973":"e3042a8be9838381c71c"}[chunkId] + ".js";
};